import { Subject } from 'rxjs'

export const ChecklistChanged = new Subject<void>()
